import routes from './account-opening.routes'

export const accountOpeningModule = {
  routes
}
